module.exports = __webpack_public_path__ + "static/media/reference-slider-20.93177aa8.jpg";